import branch from "@assets/icons/yellow-svg/Home/branch.svg";
import chuyentien from "@assets/icons/yellow-svg/Home/Chuyentien.svg";
import dautu from "@assets/icons/yellow-svg/Home/Dautu.svg";
import quanlytaikhoan from "@assets/icons/yellow-svg/Home/Quanlytaikhoan.svg";
import thanhtoantiendien from "@assets/icons/yellow-svg/Home/Thanhtoantiendien.svg";
import thanhtoan from "@assets/icons/yellow-svg/Home/Thanhtoan.svg";
import tietkiem from "@assets/icons/yellow-svg/Home/Tietkiem.svg";
import vay from "@assets/icons/yellow-svg/Home/Vay.svg";
import qr from "@assets/icons/yellow-svg/Home/QR.svg";
import tuvantaichinh from "@assets/icons/yellow-svg/Home/Tuvantaichinh.svg";
import dichvuthe from "@assets/icons/yellow-svg/Home/Dichvuthe.svg";
import chungkhoan from "@assets/icons/yellow-svg/Home/Chungkhoan.svg";
import lienketnhanh from "@assets/icons/yellow-svg/Home/Lienketnhanh.svg";

import chuyentiendinhky from "@assets/icons/yellow-svg/Chuyentien/Chuyentiendinhky.svg";
import chuyentienbangmacode from "@assets/icons/yellow-svg/Chuyentien/Chuyentienbangmacode.svg";
import chuyentiennoibo from "@assets/icons/yellow-svg/Chuyentien/Chuyentiennoibo.svg";
import chuyentiennhanhnapas247 from "@assets/icons/yellow-svg/Chuyentien/Chuyentiennhanhnapas247.svg";
import chuyentiennhanhqrcode from "@assets/icons/yellow-svg/Chuyentien/Chuyentiennhanhqrcode.svg";
import chuyentientuthien from "@assets/icons/yellow-svg/Chuyentien/Chuyentientuthien.svg";

import chuyentienliennganhang from "@assets/icons/yellow-svg/Chuyentien/Chuyentienliennganhang.svg";
import chuyentiendentaikhoanpsi from "@assets/icons/yellow-svg/Chuyentien/Chuyentiendentaikhoanpsi.svg";
import chuyentientheolo from "@assets/icons/yellow-svg/Chuyentien/Chuyentientheolo.svg";
import naptiendientu from "@assets/icons/yellow-svg/Naptien/Naptiendientu.svg";
import naptientd from "@assets/icons/yellow-svg/Naptien/naptientd.svg";
import thanhtoanhoadontudong from "@assets/icons/yellow-svg/Thanhtoanhoadon/Thanhtoanhoadontudong.svg";
import Hoadondaluu from "@assets/icons/yellow-svg/Thanhtoanhoadon/Hoadondaluu.svg";

import thongbao from "@assets/icons/yellow-svg/Common/thongbao.svg";
import dangxuat from "@assets/icons/yellow-svg/Common/dangxuat.svg";
import caidat from "@assets/icons/yellow-svg/Common/caidat.svg";
import hotline from "@assets/icons/yellow-svg/Common/hotline.svg";
import pvone from "@assets/icons/yellow-svg/Home/PVOne.svg";
import pvonelogo from "@assets/icons/yellow-svg/Home/pvonelogo.svg";
import hdbaomat from "@assets/icons/yellow-svg/Common/hdbaomat.svg";
import hdsd from "@assets/icons/yellow-svg/Common/hdsd.svg";
import cauhoithuonggap from "@assets/icons/yellow-svg/Common/cauhoithuonggap.svg";
import danhsachthuhuong from "@assets/icons/yellow-svg/Common/danhsachthuhuong.svg";
import notify from "@assets/icons/yellow-svg/Common/notify.svg";
import notfound from "@assets/icons/yellow-svg/Common/notfound.svg";

// Tiện ích
import thegioiwow from "@assets/icons/yellow-svg/Tienich/thegioiwow.svg";
import laisuat from "@assets/icons/yellow-svg/Tienich/laisuat.svg";
import timatm from "@assets/icons/yellow-svg/Tienich/timatm.svg";
import tigia from "@assets/icons/yellow-svg/Tienich/tigia.svg";

// Tiết kiệm
import nopthemtien from "@assets/icons/yellow-svg/Tietkiem/Nopthemtien.svg";
import mosotietkiem from "@assets/icons/yellow-svg/Tietkiem/Mosotietkiem.svg";
import danhsachsotietkiem from "@assets/icons/yellow-svg/Tietkiem/Danhsachsotietkiem.svg";
import tattoan from "@assets/icons/yellow-svg/Tietkiem/Tattoan.svg";

import ADSL from "@assets/icons/yellow-svg/Thanhtoanhoadon/ADSL.svg";
import Dichvucong from "@assets/icons/yellow-svg/Thanhtoanhoadon/Dichvucong.svg";
import DTcodinh from "@assets/icons/yellow-svg/Thanhtoanhoadon/DTcodinh.svg";
import DVtruyenhinh from "@assets/icons/yellow-svg/Thanhtoanhoadon/DVtruyenhinh.svg";
import homephone from "@assets/icons/yellow-svg/Thanhtoanhoadon/homephone.svg";
import Internet from "@assets/icons/yellow-svg/Thanhtoanhoadon/Internet.svg";
import leasedline from "@assets/icons/yellow-svg/Thanhtoanhoadon/leasedline.svg";
import Nuoc from "@assets/icons/yellow-svg/Thanhtoanhoadon/Nuoc.svg";
import TruyenhinhInternet from "@assets/icons/yellow-svg/Thanhtoanhoadon/TruyenhinhInternet.svg";
import Vemaybay from "@assets/icons/yellow-svg/Thanhtoanhoadon/Vemaybay.svg";

import Thongtinnguoidung from "@assets/icons/yellow-svg/Quanlytaikhoan/Thongtinnguoidung.svg";
import Quanlytaikhoan from "@assets/icons/yellow-svg/Quanlytaikhoan/Quanlytaikhoan.svg";
import SaokeTTD from "@assets/icons/yellow-svg/Quanlytaikhoan/SaokeTTD.svg";
import LichsuGDTTD from "@assets/icons/yellow-svg/Quanlytaikhoan/LichsuGDTTD.svg";

import Caidatphuongthucxacthuc from "@assets/icons/yellow-svg/Caidat/Caidatphuongthucxacthuc.svg";
import Caidattaikhoanmacdinh from "@assets/icons/yellow-svg/Caidat/Caidattaikhoanmacdinh.svg";
import CaidatthaydoigoihanmucGD from "@assets/icons/yellow-svg/Caidat/CaidatthaydoigoihanmucGD.svg";
import Caidatthongbao from "@assets/icons/yellow-svg/Caidat/Caidatthongbao.svg";
import Caidattinhnangyeuthich from "@assets/icons/yellow-svg/Caidat/Caidattinhnangyeuthich.svg";
import Doimatkhaudangnhap from "@assets/icons/yellow-svg/Caidat/Doimatkhaudangnhap.svg";
import Quanlydanhsachthuhuong from "@assets/icons/yellow-svg/Caidat/Quanlydanhsachthuhuong.svg";

import rating from "@assets/icons/yellow-svg/Common/rating.svg";
import QA from "@assets/icons/yellow-svg/Common/QA.svg";
import PVCBAbout from "@assets/icons/yellow-svg/Common/PVCBAbout.svg";
import Caidatchude from "@assets/icons/yellow-svg/Caidat/Caidatchude.svg";

import indevelopment from "@assets/icons/yellow-svg/Common/indevelopment.svg";

const icons: any = {
  thongbao,
  dangxuat,
  caidat,
  hotline,
  /**Home */
  branch,
  chuyentien,
  dautu,
  quanlytaikhoan,
  thanhtoantiendien,
  thanhtoan,
  tietkiem,
  vay,
  qr,
  tuvantaichinh,
  dichvuthe,
  chungkhoan,
  pvone,
  pvonelogo,
  hdbaomat,
  hdsd,
  cauhoithuonggap,
  lienketnhanh,
  notify,
  notfound,

  /**Chuyển tiền */
  chuyentienbangmacode,
  chuyentiennoibo,
  chuyentienliennganhang,
  chuyentiennhanhnapas247,
  chuyentiennhanhqrcode,
  chuyentiendentaikhoanpsi,
  chuyentientuthien,
  danhsachthuhuong,
  chuyentientheolo,
  chuyentiendinhky,

  naptiendientu,
  naptientd,
  thanhtoanhoadontudong,
  thegioiwow,
  tigia,
  laisuat,
  timatm,

  // Tiết kiệm
  nopthemtien,
  danhsachsotietkiem,
  mosotietkiem,
  tattoan,

  // Thanh toán hóa đơn
  Hoadondaluu,
  ADSL,
  Dichvucong,
  DTcodinh,
  DVtruyenhinh,
  homephone,
  Internet,
  leasedline,
  Nuoc,
  TruyenhinhInternet,
  Vemaybay,

  //Quản lý tài khoản
  Thongtinnguoidung,
  Quanlytaikhoan,
  SaokeTTD,
  LichsuGDTTD,

  // Cài đặt
  Caidatphuongthucxacthuc,
  Caidattaikhoanmacdinh,
  CaidatthaydoigoihanmucGD,
  Caidatthongbao,
  Caidattinhnangyeuthich,
  Doimatkhaudangnhap,
  Quanlydanhsachthuhuong,
  Caidatchude,

  //About us
  rating,
  QA,
  PVCBAbout,
  indevelopment,
};

export default icons;
